import { render, staticRenderFns } from "./PageFade.vue?vue&type=template&id=86714a52&scoped=true"
import script from "./PageFade.vue?vue&type=script&lang=js"
export * from "./PageFade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86714a52",
  null
  
)

export default component.exports